import React from 'react'
import {MDBModal, MDBModalBody, MDBModalHeader} from 'mdbreact';

class App extends React.Component{
  render(){
    return(
      <MDBModal isOpen={this.props.isOpen} toggle={this.props.toggle} size={this.props.size} className={this.props.className}>
        <MDBModalHeader toggle={this.props.toggle}>{this.props.header}</MDBModalHeader>
        <MDBModalBody>
          {this.props.children}
        </MDBModalBody>
      </MDBModal>
    );
  }
}

export default App;
